<template>
  <!-- Topbar -->
  <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
    <!-- Sidebar Toggle (Topbar) -->
    <button class="btn btn-light" type="button" @click="$emit('toggle-sidebar')">
      <font-awesome-icon class="icon" icon="bars" />
    </button>
    <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3"></button>
    {{appVersion}}
    <!-- Topbar Navbar -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item d-flex align-items-center mr-3">
        <a
          class="btn btn-outline-primary btn-sm"
          href="https://app.preview.skischule-unterland.de/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vorschauversion öffnen
        </a>
      </li>
      <div class="topbar-divider d-none d-sm-block"></div>

      <!-- Nav Item - User Information -->
      <li
        class="nav-item dropdown"
        :class="{ show: userMenuOpen }"
        v-if="loggedIn"
      >
        <a
          class="nav-link dropdown-toggle nav-link-custom"
          href="#"
          role="button"
          aria-haspopup="true"
          :aria-expanded="userMenuOpen ? 'true' : 'false'"
          @click.prevent="toggleUserMenu"
        >
          <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{name}}</span>
          <div class="avatar-sm rounded-circle bg-secondary d-inline-block align-middle"></div>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right shadow"
          :class="{ show: userMenuOpen }"
        >
          <button class="dropdown-item" type="button" @click="logout">
            Logout
          </button>
        </div>
      </li>
    </ul>
    
  </nav>
  <!-- End of Topbar -->
</template>

<script>

import { AuthenticationContext } from "@/auth/msal-context";
export default {
  name: "NavbarComponent",
  emits: ["toggle-sidebar"],
  computed: {
    appVersion() {
      return this.$store.getters.appVersion;
    },
    name() {
      return AuthenticationContext.getActiveAccount()?.name;
    },
    loggedIn() {
      return AuthenticationContext.isAuthenticated();
    }
  },
  data() {
    return {
      userMenuOpen: false,
    };
  },
  methods: {
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    logout() {
      this.userMenuOpen = false;
      AuthenticationContext.logout();
    }
  }
};
</script>
